export const COMPANY_LEGAL_FORM_CHOICES = [
  { label: "Société à responsabilité limitée", value: "SARL" },
  { label: "Société anonyme", value: "SA" },
  { label: "Entreprise individuelle", value: "EI" },
  { label: "Entreprise unipersonnelle à responsabilité limitée", value: "EURL" },
  { label: "Société par actions simplifiée (SAS) ou société par actions simplifiée unipersonnelle", value: "SASU" },
  { label: "Société en nom collectif", value: "SNC" },
  { label: "Société coopérative de production", value: "SCOP" },
  { label: "Société en commandite par actions", value: "SCA" },
  // { label: "Société en commandite par actions", value: "SCA" },
  { label: "Société en commandite simple", value: "SCS" },
  { label: "Organisation non gouvernementale", value: "ONG" }
]

export const riskRates = {
  bj: [1, 2, 3, 4, 5],
  ci: [2, 3, 4, 5],
};

export const SUITABLE_LABEL = {
  bj: {
    ifu: "Identifiant Fiscal Unique (IFU)",
    ifuFile: "Attestation IFU",
    rccm: "Numéro RCCM",
    rccmFile: "RCCM",
    employerCnss: "Numéro CNSS employeur",
    cnssMask: "99 99 99 99 99 99 99",
    cnssPlaceholder: "XX XX XX XX XX XX XX",
  },
  ci: {
    ifu: "Numéro d’identifiant unique (IDU)",
    ifuFile: "Certificat IDU",
    rccm: "Numéro de Compte Contribuable (NCC)",
    rccmFile: "NCC",
    employerCnss: "Numéro CNPS employeur",
    cnssMask: "99 99 99 99 99 99",
    cnssPlaceholder: "XX XX XX XX XX XX",
  },
};

export const TAX_SYSTEMS = {
  bj: [
    { value: "TPS", label: "Régime TPS" },
    { value: "RR", label: "Régime réel (CA supérieur à 50 millions)" },
  ],
  ci: [
    { value: "RE", label: "Régime de l’entreprenant (RE)" },
    { value: "RME", label: "Régime des microentreprises (RME)" },
    { value: "RSI", label: "Régime du réel simplifié d’imposition (RSI)" },
    { value: "RNI", label: "Régime du réel normal d’imposition (RNI)" },
  ],
};

export const ACTIVITY_SECTORS = [
  { value: "banque", label: "Banque" },
  { value: "assurance", label: "Assurance" },
  {
    value: "agriculture-maintenance",
    label:
      "Agricole, Elevage et Foresterie, Haras, entreprises de Marais salants, d’entretien et de mise en état des jardins",
  },
  { value: "production-agricole", label: "Production Agricole" },
  {
    value: "petrol-distribution",
    label: "Entreprises pétrolières de distribution",
  },
  {
    value: "petrol-exploration",
    label: "Entreprises pétrolières d’exploration-production",
  },
  { value: "polygraphie", label: "Industrie polygraphique" },
  {
    value: "industrie-mecanique",
    label:
      "Industrie mécanique - industrie alimentaire, des corps gras industrie chimique, transport et autres, étendu au GIPAME",
  },
  { value: "industrie-bois", label: "Industrie du bois" },
  {
    value: "commerce-distribution",
    label:
      "Commerce, Distribution, négoce et professions libérales, étendu au GIPAME pour ses activités relevant de ce secteur",
  },
  { value: "gens-maison", label: "Gens de maison" },
  { value: "hotellerie-tourisme", label: "Hôtellerie-Tourisme" },
  { value: "industrie-textile", label: "Industrie textile" },
  { value: "dockers", label: "Dockers (SEMPA-BMOD)" },
  { value: "industrie-thon", label: "Industrie de transformation de thon" },
  {
    value: "batiment-tp",
    label: "Bâtiment, Travaux Publics et activités connexes",
  },
  { value: "securite-privee", label: "Sécurité Privée" },
  { value: "industrie-sucre", label: "Industrie du sucre" },
  { value: "instituts-recherche", label: "Instituts de recherche" },
  { value: "transport-fonds", label: "Transport de fonds et valeurs" },
  { value: "auxiliaires-transport", label: "Auxiliaires du Transport" },
  { value: "transport-aerien", label: "Transport aérien" },
  { value: "nettoyage-salubrite", label: "Nettoyage et salubrité" },
  { value: "secteur-maritime", label: "Secteur Maritime : pêche fraîche" },
];

export const MONTHS_NUMBER = {
  Mensuel: 1,
  Trimestriel: 3,
  Semestriel: 6,
  Annuel: 12,
};

export const INCOME_STATUS = {
  "on_time": "on_time",
  late: "late",
  collection: "collection",
}